import { render, staticRenderFns } from "./how_it_works.vue?vue&type=template&id=06b66937&"
import script from "./how_it_works.vue?vue&type=script&lang=ts&"
export * from "./how_it_works.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports